import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { AuthService } from '../shared/services/auth/auth.service';
import { AuthStateService } from '../shared/services/auth/auth-state.service';

export const AuthGuard: CanActivateFn = (): Observable<boolean> => {
  const authState: AuthStateService = inject(AuthStateService);
  const authService: AuthService = inject(AuthService);

  const token: string = authState.unverifiedTokenSnapshot;

  if (!token) {
    authService.login();
    return of(false);
  }

  return authService.sync().pipe(
    switchMap((): Observable<boolean> => authState.isLoggedIn$),
    take(1),
    tap((isLoggedIn): void => {
      if (!isLoggedIn) {
        authService.login();
      }
    })
  );
};
